import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { useDispatch, useSelector } from 'react-redux';
import { setContainerFloors } from '../Reducers/Configurator/Actions';
import { getContainer } from '../Reducers/Configurator/Selectors';
import Typography from '@material-ui/core/Typography';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';

const useStyles = makeStyles(
  (theme) => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
    },
    form: {
      paddingLeft: '25px',
    },
  }),
  { name: 'ContainerRowSelection' }
);

export const ContainerFloorSelection = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const container = useSelector(getContainer);
  const floors = container.floors || 1;
  const handleFloorsChange = (event) => {
    const floors = parseFloat(event.target.value);
    dispatch(setContainerFloors(floors));
  };
  return (
    <div className={classes.container}>
      <Typography>{t('containerFloorSelection.selectFloorAmount')}</Typography>
      <FormControl className={classes.form} component="fieldset">
        <RadioGroup row aria-label="floors" value={floors} onChange={handleFloorsChange}>
          <FormControlLabel
            value={1}
            control={<Radio color={'primary'} />}
            label={t('containerFloorSelection.oneFloor')}
          />
          <FormControlLabel
            value={2}
            control={<Radio color={'primary'} />}
            label={t('containerFloorSelection.twoFloors')}
          />
          <FormControlLabel
            value={3}
            control={<Radio color={'primary'} />}
            label={t('containerFloorSelection.threeFloors')}
          />
        </RadioGroup>
      </FormControl>
    </div>
  );
};

export default ContainerFloorSelection;
